export const Loader = ({ color = '' }) => {
    return (
        <div className="loader">
            <span style={color ? { backgroundColor: color } : {}}></span>
            <span style={color ? { backgroundColor: color } : {}}></span>
            <span style={color ? { backgroundColor: color } : {}}></span>
        </div>
    );
};
